// removed by extract-text-webpack-plugin
module.exports = {"root":"bags--root--1VFj18Su organization-home--root--29mpR9MJ","grid-container":"bags--grid-container--2OiS7i4F home--grid-container--3c3JLjRI","gridContainer":"bags--grid-container--2OiS7i4F home--grid-container--3c3JLjRI","form-container":"bags--form-container--3_rXmf2v home--message--9FSspPIv","formContainer":"bags--form-container--3_rXmf2v home--message--9FSspPIv","title":"bags--title--3u93PUQb crops--title--3nbOw3vq","modify-form":"bags--modify-form--1R9oTIlF undefined","modifyForm":"bags--modify-form--1R9oTIlF undefined"};


//////////////////
// WEBPACK FOOTER
// ./views/lado-a-lado/multiplier/bags/styles.css
// module id = ./views/lado-a-lado/multiplier/bags/styles.css
// module chunks = 0